//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TextareaBlock from 'components/combinedBlocks/Textarea.vue'
import InputFormBlock from 'components/combinedBlocks/InputForm.vue'
import ButtonBlock from 'components/blocks/Button.vue'

export default {
  block: 'getStarted',
  props: ['data'],
  data() {
    return {
      success: false,
      emailInvalid: false,
      visible: this.data.visible || false,
      // allowStoreData: false,
    }
  },
  components: {
    TextareaBlock,
    InputFormBlock,
    ButtonBlock,
  },
  computed: {
    // allFieldsIsValid() {

    //   console.log("Validate orig data: ", this.origData);

    //   if((this.data.email == "" || this.data.email == this.origData.email) ||
    //     (this.data.name == "" || this.data.name == this.origData.name) ||
    //     (this.data.message == "" || this.data.message == this.origData.message) ||
    //     this.data.allowStoreData == false) {
    //     return false
    //   }

    //   return true;
    // },
  },
  methods: {
    close(){
      // Inform parent that getStarted should close
      this.$emit('getStartedClosed');
    },
    allowStoreData(event) {
      this.data.allowStoreData = event.target.checked;
    },
    sendMessage() {
      // if (this.allFieldsIsValid) {
        this.$http.post('/api/email', {
          mailto: this.data.mailto,
          subject: this.data.subject,
          name: this.data.name,
          email: this.data.email,
          phone: this.data.phone,
          companyName: this.data.companyName,
          allowStoreData: this.data.allowStoreData,
          message: this.data.message
        }).then(function(response) {
          if(response.body == "1") {
            this.data.subject = "";
            this.data.name = "";
            this.data.email = "";
            this.data.phone = "",
            this.data.companyName = "",
            this.data.allowStoreData = false;
            this.data.message = "";

            this.success = true;
            this.emailInvalid = false;
          } else if(response.body == "0") {
            this.emailInvalid = true;
          }
        }, function(response) {
          alert('Email could not be sent. Server error.')
        });
      // }

    },

  },
  watch: {
    'data.visible': function(value) {
      this.visible = value;
    },
  },
  mounted() {
    // console.log("Store labels: ", this.data);
    this.origData = this.data;
  }
}



// WEBPACK FOOTER //
// ./components/combinedBlocks/GetStarted.vue